import React from 'react';
// Components
import Tool from '../Tool/Tool.jsx';
import Canvas from '../Canvas/Canvas.jsx';

// Styles
import styles from './FormBuilderTool.module.css';

// Constants
import { getUserSideFormTypes } from '../../constants/formTypes';
import { getUserSideTemplateTypes } from '../../constants/templateTypes';
import { useAutoTranslation } from 'src/hooks/useTranslate';

function FormBuilderTool() {
  const formTools = getUserSideFormTypes();
  const templates = getUserSideTemplateTypes();
  const t = useAutoTranslation();

  return (
    <div className={styles.FomBuilderContainer}>
      <div className={styles.FormCanvas}>
        <Canvas />
      </div>
      <aside className={styles.FormToolsContainer}>
        <div className={styles.PanelHeader}>
          <span className={styles.PanelTitle}>{t('Form elements')}</span>
          <p className={styles.PanelHint}>
            {t('Drag a block onto a section to add a question.')}
          </p>
        </div>

        <div className={styles.ToolGroup}>
          <div className={styles.GroupHeader}>{t('Tools')}</div>
          <div className={styles.FormToolsInnerContainer}>
            {formTools.map((tool, index) => (
              <Tool
                key={`Tool_${index}`}
                toolName={tool.value}
                tool={tool}
                type="tool"
              />
            ))}
          </div>
        </div>

        <div className={styles.ToolGroup}>
          <div className={styles.GroupHeader}>{t('Templates')}</div>
          <div className={styles.FormToolsInnerContainer}>
            {templates.map((tool, index) => (
              <Tool
                key={`Template_${index}`}
                toolName={tool.value}
                tool={tool}
                type="template"
              />
            ))}
          </div>
        </div>
      </aside>
    </div>
  );
}

export default FormBuilderTool;
